var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.alertsEnabled && !_vm.$pubCtx.alert.disabled)?_c('div',{staticClass:"alert-safeguard"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }